<script setup lang="ts">
import HomeDisplay from '@/components/HomeDisplay.vue';

</script>

<template>
  <HomeDisplay/>
</template>
